import api from "../../index";

export const GetSalesDashboardApi = (params) => api.get(`SalesDashboard/Get-Sales-Lead-Dashboard?${params}`);